"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = require("underscore");

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URL = '/esp-sync/v1/settings';
var _default = {
  fetchSettings: function fetchSettings() {
    return _apiClient.default.get(BASE_URL);
  },
  submitSettings: function submitSettings(data) {
    data = (0, _underscore.pick)(data, 'espApiKey', 'espType');
    return _apiClient.default.patch(BASE_URL, {
      data: data
    });
  },
  removeLastEmailSyncError: function removeLastEmailSyncError() {
    var data = {
      espLastError: ''
    };
    return this.submitSettings(data);
  }
};
exports.default = _default;
module.exports = exports.default;